import { Paper as MuiPaper } from '@material-ui/core';
import { withDefaultPropsAndStyles } from '../utils';
export const Paper = withDefaultPropsAndStyles('Paper', MuiPaper, {
    styles: () => ({
        // NOTE: these empty styles need to exist here in order for the
        // theme-specific overrides to be applied.
        root: {},
        rounded: {},
    }),
});
//# sourceMappingURL=Paper.js.map